import {ActionEnum} from "../action.enum";

export namespace ChecklistTemplateOverallAssessmentAction {

  export class Fetch {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_OVERALL_ASSESSMENT_FETCH;
    constructor (public checklistTemplateVersionId: string) {}
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_OVERALL_ASSESSMENT_RESET;
  }
}
